import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'
import { Controller, useWatch } from 'react-hook-form'

import {
  IconPicker,
  IconPickerTrigger,
} from '~/client/src/shared/components/IconPicker'

import { IconFieldConfig } from '../types'

interface IconFieldProps {
  field: IconFieldConfig
  control: any
  error?: string
}

const IconField: React.FC<IconFieldProps> = ({ field, control, error }) => {
  const { isMobileEnv } = React.useContext(MobXProviderContext) as {
    isMobileEnv?: boolean
  }
  const watchedKind = useWatch({
    control,
    name: field.kindFieldName ?? field.name,
    disabled: !field.kindFieldName,
  })

  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={field.defaultValue ?? undefined}
      render={({ field: { onChange, value } }) => {
        const current = value || field.catalog.struxhub[0]
        return (
          <div className="tw:flex tw:flex-col tw:gap-1">
            <span className="tw:text-body-sm tw:font-medium tw:text-muted-foreground">
              {field.label}
            </span>
            <IconPicker
              value={current}
              onChange={onChange}
              catalog={field.catalog}
              kind={field.kindFieldName ? (watchedKind as string) : null}
              disabled={field.disabled || field.readOnly || field.displayOnly}
              isMobileMode={isMobileEnv}
            >
              <IconPickerTrigger
                value={current}
                displayOnly={field.displayOnly}
              />
            </IconPicker>
            {error && (
              <span className="tw:text-body-sm tw:text-destructive">
                {error}
              </span>
            )}
          </div>
        )
      }}
    />
  )
}

export default IconField
